import { CsatActions, GenexActions } from 'core/enums/genex';
import { useAppContext, usePlatform, useTriggerSurvey } from 'core/hooks';
import { ModelWithCategory, OptionalUserData } from 'core/stores/genex.store';

export enum SurveyType {
  Setup, Cancel, Update
}

const useTriggerRecurringPaymentSurvey = () => {
  const triggerSurvey = useTriggerSurvey();
  const appContext = useAppContext();
  const { genexActionCode } = usePlatform();

  const getSurveyModel = (type: SurveyType): ModelWithCategory => {
    const defaults = {
      outcome: 'Success',
      //journeyName: 'Help',
    };

    switch (type) {
      case SurveyType.Setup:
        return {
          ...defaults,
          category: GenexActions.RecurringPaymentSetup,
          surveyName: genexActionCode(CsatActions.RecurringPaymentSetup),
          eventDescription: 'setting up your recurring payment',
        };

      case SurveyType.Cancel:
        return {
          ...defaults,
          category: GenexActions.RecurringPaymentCancel,
          surveyName: genexActionCode(CsatActions.RecurringPaymentCancel),
          eventDescription: 'cancelling your recurring payment',
        };

      case SurveyType.Update:
        return {
          ...defaults,
          category: GenexActions.RecurringPaymentUpdate,
          surveyName: genexActionCode(CsatActions.RecurringPaymentUpdate),
          eventDescription: 'updating your recurring payment',
        };
    }
  };

  const getCustomerAccountType = (type: SurveyType) => {
    switch (type) {
      case SurveyType.Setup:
        return 'set up your recurring payment';

      case SurveyType.Cancel:
        return  'cancel your recurring payment';

      case SurveyType.Update:
        return 'update your recurring payment';
    }
  };

  return (type: SurveyType) => {
    const surveyModel = getSurveyModel(type);
    const userData: OptionalUserData = {
      customerAccountType: getCustomerAccountType(type),
      country: appContext.countryName,
      countryCode: appContext.country,
    }

    triggerSurvey(surveyModel, userData);
  };
};

export default useTriggerRecurringPaymentSurvey;